import { GuardedComponent } from '../components/guarded-component';
import { GuardedComponentMulti } from '../components/guarded-component-multi';
import { InspectorCalendarPage } from '../features/inspector-calendar/inspector-calendar.page';
import { UserPermissionName } from '../models/user-permission-name';

export const InspectorCalendarRoute = {
  path: '/inspector-calendar',
  name: 'Inspector Calendar',
  element: (
    <GuardedComponentMulti
      // requiredPermissions={[UserPermissionName.VIEW_OWN_CALENDAR] || [UserPermissionName.VIEW_ALL_CALENDAR]}
      requiredPermissions={[
        UserPermissionName.VIEW_OWN_CALENDAR,
        UserPermissionName.VIEW_ALL_CALENDAR,
        UserPermissionName.VIEW_TEAM_CALENDAR,
      ]}
      showPermissionError
    >
      <InspectorCalendarPage />
    </GuardedComponentMulti>
  ),
};
